module.exports = __webpack_public_path__ + "slide-2.jpg?c3afef63b4487249382e1229b62c7859";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide-2.jpg
// module id = 64
// module chunks = 0